export default __webpack_public_path__ + "assets/b9610c0bdee6f97a723a382cadb3dd9c-templates-email-contact.svg";